import { render, staticRenderFns } from "./DataCreativeIndustry.vue?vue&type=template&id=75edf311&scoped=true"
import script from "./DataCreativeIndustry.vue?vue&type=script&lang=js"
export * from "./DataCreativeIndustry.vue?vue&type=script&lang=js"
import style0 from "./DataCreativeIndustry.vue?vue&type=style&index=0&id=75edf311&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75edf311",
  null
  
)

export default component.exports